import React, { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import './write.css'
import axios from "axios"
import { Context } from '../../context/Context';
import BottomNav from '../../components/bottomnav/BottomNav';
import ProgressBar from '../../components/progressbar/ProgressBar';
import Navbar from '../../components/navbar/Navbar';
import { Notify} from "notiflix";
import { Switch } from 'antd';
import 'antd/dist/antd.css';

function Write() {
    const [title, setTitle] = useState("");
    const [desc, setDesc] = useState("");
    const [cat, setCat] = useState([]);
    const [cats, setCats] = useState([]);
    const [url, setUrl] = useState("");
    const [file, setFile] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [loadingPerc, setloadingPerc] = useState(0);
    const [checked, setChecked] = useState(false);

    const history = useHistory();
    const {user} = useContext(Context);
    const api_uri = "https://mentorxfa.herokuapp.com/api";
    const PF = "https://mernblog.s3.amazonaws.com/";

    const uploadConfig = {
        onUploadProgress: progressEvent => {    
            setloadingPerc(parseInt(Math.floor((progressEvent.loaded * 100) / progressEvent.total)));                 
        }
    }

    Notify.init({
        position: 'right-top'
    })

    useEffect(() => {
        const fetchPosts = async() => {
            const res = await axios.get(api_uri +"/categories");
            setCats(res.data);
           
        }
        fetchPosts() 
        return () => {
            setTitle("")
            setDesc("")
            setCat([])
            setCats([])
            setUrl("")
            setIsLoading(true)
          };
    }, []);

    const handleSubmit = async (e)=>{
        e.preventDefault();        
        
        const newPost = {
            username: user.username,
            title,
            desc,
            categories: cat,
            url
        }
        if(file && checked){
            const data = new FormData();
            const filename = "mentorX_" + Date.now()+ "_" + file.name;
            data.append("name", filename);
            data.append("file", file);
            newPost.url = PF + filename;
            try {
                await axios.post(api_uri+"/upload", data,uploadConfig);   
            } catch (err) {
                console.log(err);
                Notify.failure('Error uploading post');
            }
        }
        try {
            if(!checked){
                const res = await axios.post(api_uri+"/posts", newPost, uploadConfig);               
                setTimeout(() => {     
                    setIsLoading(false)
                    Notify.success('Post Uploaded Successfully');
                }, 350) 
                setTimeout(() => {     
                    history.push("/posts/"+res.data._id)
                }, 500)    
            }else{
                const res = await axios.post(api_uri+"/posts", newPost);
                Notify.success('Post Uploaded Successfully');
                setTimeout(() => {     
                    setIsLoading(false)
                }, 250) 
                setTimeout(() => {     
                    history.push("/posts/"+res.data._id)
                }, 380)  
            }
                    
        } catch (err) {
            console.log(err);
            Notify.failure('Error uploading post');
        }
    }

    return (
        <>
        <Navbar/>
        {
            isLoading && <ProgressBar percentage={loadingPerc}/>
        }
            <div className="write">
                <h2 className="write-title">Upload post</h2>  
            <form action="#" className="write-form" onSubmit={handleSubmit} >                               
                <select required  className="write-input" onChange={(e) => {setCat([...cat, e.target.value || e.state.selected])}}>
                    <option value=" " defaultValue>Select Category</option>
                    {
                        cats.map((c) =>(
                            <option key={c._id} value={c.name} >{c.name}</option>
                        ))
                    }
                </select>                          
                <input type="text" required  className="write-input" placeholder="Title" onChange={e => setTitle(e.target.value)}/>        
                <textarea placeholder="Description" required type="text" className="write-desc"  onChange={e => setDesc(e.target.value)} >
                </textarea>   
                <div className="switching">                   
                    <Switch onChange={() => setChecked(!checked)} />   
                </div>               
                {
                    checked ?   <label htmlFor="file-input">
                                    <div className="write-input upload-btn" >Upload a file</div>
                                    <input id="file-input" type="file" style={{display:"none"}} onChange={(e) => setFile(e.target.files[0])} />
                                </label> 
                            :   <input type="text" required  className="write-input" placeholder="Download Link" onChange={e => setUrl(e.target.value)}  />
                }               
                <button className="write-submit-btn">Post</button>      
            </form>  
        </div>
        <BottomNav/>
        </>
    )
}

export default Write
